import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';
import { OUTPUT_TYPE_ICON, getResultHintKey } from '@/components/Tools/toolDetailHelpers';

function ToolEmptyResult({ tool }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const palette = getCatalogPalette(theme);
  return (
    <View style={{ minHeight: 320, padding: 28, borderRadius: 20, borderWidth: 1, borderColor: palette.border,
      backgroundColor: palette.surface, alignItems: 'center', justifyContent: 'center', gap: 16 }}>
      <View style={{ width: 56, height: 56, borderRadius: 16, backgroundColor: palette.preview, alignItems: 'center', justifyContent: 'center' }}>
        <Icon name={OUTPUT_TYPE_ICON[tool?.outputType] || 'sparkles'} size={24} color={palette.icon} />
      </View>
      <Text size="s" color="secondary" style={{ textAlign: 'center', maxWidth: 260, lineHeight: 21 }}>
        {t(getResultHintKey(tool?.outputType)) || 'Your result will appear here.'}
      </Text>
    </View>
  );
}

export default React.memo(ToolEmptyResult);
